<template>
    <v-container>
      <div>
        <v-row justify="space-between">
            <v-col cols="12" sm="6" justify="center">
                <p class="header-title"> {{$t('customer_management.title')}} </p>
            </v-col>

            <v-col cols="12" sm="6" justify="center" class="pr-5">
                <div class="d-flex flex-row-reverse">
                  <v-btn color="primary" dark @click="addNewCustomer">{{ $t('common.add_customer')}}</v-btn>
                  <v-btn color="primary" dark @click="getData" class="mr-5">{{ $t('common.refresh')}}</v-btn>
                </div>
            </v-col>
        </v-row>
      </div>
      <v-data-table :headers="headers" :items="desserts" :search="search" :loading="loading" class="elevation-1" hide-default-footer :page.sync="page" :items-per-page="itemsPerPage"  @page-count="pageCount = $event">
          <template v-slot:top>
              <v-toolbar flat color="white" class="pt-5">
                <v-row justify="start">
                  <v-col cols="12" sm="1">
                      <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined dense></v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="2">
                  </v-col>
                  
                  <v-col cols="12" sm="2">
                  </v-col>

                  <v-col cols="12" sm="7">
                    <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line hide-details outlined dense></v-text-field>
                  </v-col>
                </v-row>
              </v-toolbar>
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <div class="contentTitle">
              <v-icon  small class="mr-2"  @click="editItem(item)">
                  edit
              </v-icon>
              <v-icon  small @click="deleteItem(item)">
                  delete
              </v-icon>
            </div>
          </template>

          <template v-slot:[`item.email`]="{ item }">
              <span class="text-no-wrap">
                {{ item.email }}
              </span>
          </template>

          <template v-slot:[`item.fullname`]="{ item }">
              <span class="text-no-wrap">
                {{ item.fullname }}
              </span>
          </template>

          <template v-slot:[`item.phone`]="{ item }">
              <span class="text-no-wrap">
                {{ item.phone }}
              </span>
          </template>

          <template v-slot:[`item.facebook`]="{ item }">
              <span class="text-no-wrap">
                {{ item.facebook }}
              </span>
          </template>

          <template v-slot:[`item.birthday`]="{ item }">
              <span class="text-no-wrap">{{item.birthday | formateDate}}</span>
          </template>

          <!-- <template v-slot:[`item.defaultAddress`]="{ item }">
              <span>{{addressToString(item.defaultAddress)}}</span>
          </template> -->

          <template v-slot:no-data>
              <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
          </template>
      </v-data-table>

      <div class="text-center pt-2">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </div>

      <customer-dialog :showDialog="dialog" :editedItem="editedItem" :editedIndex="editedIndex" @closeDialog="closeDialog" @updateCustomer="updateCustomer" v-if="editedItem"> 
      </customer-dialog>
    </v-container>


</template>

<script>
  import i18n from '@/plugins/i18n';
  import CustomerDialog from "@/components/CustomerDialog";

  export default {
    data: () => ({
      e1: 0,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,

      loading: true,
      numberPage: [
        5, 10, 15, 20, 25
      ],

      date: '',
      modal: false,


      search: '',
      dialog: false,

      headers: [
        { text: '#', align: 'left', sortable: false, value: 'index'},
        { text: i18n.t('profile.fullname'), value: 'fullname' },
        { text: i18n.t('profile.email'), value: 'email' },
        { text: i18n.t('profile.phone'), value: 'phone', sortable: false},
        { text: i18n.t('profile.facebook'), value: 'facebook', sortable: false},
        { text: i18n.t('profile.birthday'), value: 'birthday', sortable: false },
        // { text: i18n.t('customer_management.address'), value: 'defaultAddress', sortable: false },
        { text: '', value: 'action', sortable: false }
      ],

      desserts: [],
      editedIndex: -1,
      editedItem: null,
      defaultItem: {
      },

      stringRules: [
          v => !!v || i18n.t('validate.not_empty'),
          // v => (v && v.length > 5) || i18n.t('validate.string_invalid')
      ],
      phoneRules: [
          v => !!v || i18n.t('validate.not_empty'),
          v => (v && v.length > 9) || i18n.t('validate.phone_invalid'),
      ],
      addressRules: [
          v => !!v || i18n.t('validate.not_empty'),
          // v => (v && v.length > 5) || i18n.t('validate.address_invalid'),
      ],
      emailRules: [
          v => !!v || i18n.t('validate.email_require'),
          v => /.+@.+\..+/.test(v) || i18n.t('validate.email_invalid'),
      ],
      passdRules: [
          v => !!v || i18n.t('validate.password_require'),
          v => (v && v.length > 5) || i18n.t('validate.password_invalid'),
      ],
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? i18n.t('customer_management.add_management') : i18n.t('customer_management.edit_management')
      },

      computedDateFormatted () {
        return this.formatDate(this.date)
      },
    },

    components: {
        CustomerDialog: CustomerDialog
    },

    watch: {
    },

    async created () {
      // await this.getProvince(),
      await this.getData()
    },

    methods: {
      formatDate (date) {
        if (!date) {
          return null;
        }

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
      },

      closeDialog(value) {
        this.dialog = value
        this.editedItem = null;
      },

      updateCustomer(value) {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], value);
        } else {
          this.desserts.push(value);
        }
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        // console.log(this.editedItem);

        this.dialog = true;
        // this.dialogEdit = true;
      },

      addNewCustomer () {
        this.editedIndex = -1;
        this.editedItem = {};
        this.dialog = true;
        // this.dialogEdit = true;
      },

      async deleteItem (item) {
        const agree = confirm(i18n.t('common.confirm_delete'))
        if (agree) {
          const response =  await this.$http.delete(process.env.VUE_APP_CUSTOMER_API + item._id);
          if(response.data && response.data.success) {
              // console.log(response.data);
              this.desserts.splice(item.index - 1, 1);
              this.desserts.forEach((item, index) =>item.index = index + 1);
          } else if(response.data && !response.data.success) {
              alert(i18n.t(response.data.message));
          } else {
              alert(i18n.t('validate.request_error'));
          }
        }
      },

      async getData() {
        this.loading = true;
        try {
            const response =  await this.$http.get(process.env.VUE_APP_CUSTOMER_API);
            if(response.data && response.data.success) {
                // console.log(response.data);
                
                const contextArr = response.data.data;
                contextArr.forEach((item, index) =>item.index = index + 1);

                this.desserts = contextArr;

                this.loading = false;
            } else if(response.data && !response.data.success) {
                alert(i18n.t(response.data.message));
            } else {
                alert(i18n.t('validate.request_error'));
            }
        } catch(e) {
            console.log(e.stack);
            alert(i18n.t('validate.request_error'));
        }
      },

      addressToString(detail) {
        if (detail && detail.fullDetail) {
          return detail.fullDetail;
        } else {
          return '';
        }
      },
    },
  }
</script>

<style scoped>
  fixed-tabs-bar .v-tabs__bar {
    position: -webkit-sticky;
    position: sticky;
    top: 4rem;
    z-index: 2;
  }

  .v-text-field .v-input__control .v-input__slot {
    min-height: 45px !important;
    /* display: flex !important; */
    align-items: center !important;
  }
</style>
